module.exports = __webpack_public_path__ + "static/img/daniel-salcius-g-ehJqwYSyU-unsplash_thumb.c951600.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/daniel-salcius-g-ehJqwYSyU-unsplash_thumb.png
// module id = wV/X
// module chunks = 4